<template>
    <iframe :src="match.streamEmbed" allow="fullscreen" width="100%" height="280" style="border: none" />
</template>

<script>
export default {
  name: 'liveStream',
  props: ['match'],
  data () {
    return {

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/sportsbook/widget/liveStream.vue